import React from 'react';
import { Input, Select } from './UI';

// Comércio exterior (CE1/CE2). Cadastro do parceiro estrangeiro (cliente/fornecedor do
// exterior) e dados de importação do item (DI/DUIMP, adição e Imposto de Importação), que o
// operador copia do espelho do despachante — o sistema não calcula tributos de importação.

export const VIAS_TRANSPORTE = [
  ['1', 'Marítima'], ['2', 'Fluvial'], ['3', 'Lacustre'], ['4', 'Aérea'], ['5', 'Postal'],
  ['6', 'Ferroviária'], ['7', 'Rodoviária'], ['8', 'Conduto'], ['9', 'Meios próprios'],
  ['10', 'Entrada/saída ficta'], ['11', 'Courier'], ['12', 'Em mãos'], ['13', 'Por reboque'],
];

export function ParceiroEstrangeiro({ form, setForm, paises }) {
  const campo = (k) => ({ value: form[k] || '', onChange: e => setForm({ ...form, [k]: e.target.value }) });
  return (
    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0 16px' }}>
      <Input label="Nome *" style={{ gridColumn: '1/3' }} maxLength={60} contador {...campo('razao_social')} />
      <Select label="Tipo" value="E" onChange={e => setForm({ ...form, tipo_documento: e.target.value })}>
        <option value="J">Pessoa Jurídica</option>
        <option value="F">Pessoa Física</option>
        <option value="E">Estrangeiro (exterior)</option>
      </Select>
      <Select label="País *" {...campo('codigo_pais')}>
        <option value="">— Selecione —</option>
        {paises.map(p => <option key={p.codigo} value={p.codigo}>{p.nome}</option>)}
      </Select>
      <Input label="Identificação no exterior (opcional, 5 a 20)" maxLength={20} {...campo('id_estrangeiro')} />
      <Input label="E-mail" maxLength={60} {...campo('email')} />
      <Input label="Endereço *" style={{ gridColumn: '1/3' }} maxLength={60} {...campo('logradouro')} />
      <Input label="Número *" maxLength={60} {...campo('numero')} />
      <Input label="Bairro/distrito *" maxLength={60} {...campo('bairro')} />
      <Input label="Código postal (opcional)" maxLength={8} {...campo('cep')} />
      <div style={{ fontSize: '12px', color: '#666', alignSelf: 'center' }}>
        Na nota: UF "EX", município "EXTERIOR", sem CPF/CNPJ e sem Inscrição Estadual.
      </div>
    </div>
  );
}

export function ImportacaoItem({ item, upd, idx, inp, F, MoneyInput }) {
  const di = item.importacao || { adicoes: [{}] };
  const ii = item.imposto_importacao || {};
  const ad = (di.adicoes && di.adicoes[0]) || {};
  const setDi = (k, v) => upd(idx, 'importacao', { ...di, [k]: v });
  const setAd = (k, v) => upd(idx, 'importacao', { ...di, adicoes: [{ ...ad, [k]: v }] });
  const setIi = (k, v) => upd(idx, 'imposto_importacao', { ...ii, [k]: v });
  const txt = (val, on, max) => <input style={inp} value={val || ''} maxLength={max} onChange={e => on(e.target.value)} />;
  return (
    <div style={{ border: '1px dashed #ccc', borderRadius: '8px', padding: '10px 12px', margin: '8px 0' }}>
      <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
        Importação — copie do espelho do despachante (o emissor não calcula tributos de importação).
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
        <F label="Nº da DI/DUIMP" required>{txt(di.nDI, v => setDi('nDI', v), 15)}</F>
        <F label="Data de registro" required><input type="date" style={inp} value={di.dDI || ''} onChange={e => setDi('dDI', e.target.value)} /></F>
        <F label="Data do desembaraço" required><input type="date" style={inp} value={di.dDesemb || ''} onChange={e => setDi('dDesemb', e.target.value)} /></F>
        <F label="UF do desembaraço" required>{txt(di.UFDesemb, v => setDi('UFDesemb', v.toUpperCase()), 2)}</F>
        <F label="Local do desembaraço" required>{txt(di.xLocDesemb, v => setDi('xLocDesemb', v), 60)}</F>
        <F label="Via de transporte" required>
          <select style={inp} value={di.tpViaTransp || ''} onChange={e => setDi('tpViaTransp', e.target.value)}>
            <option value="">—</option>
            {VIAS_TRANSPORTE.map(([c, n]) => <option key={c} value={c}>{c} - {n}</option>)}
          </select>
        </F>
        {di.tpViaTransp === '1' && (
          <F label="AFRMM R$" required><MoneyInput style={inp} value={di.vAFRMM || 0} onChange={v => setDi('vAFRMM', v)} /></F>
        )}
        <F label="Forma de importação" required>
          <select style={inp} value={di.tpIntermedio || ''} onChange={e => setDi('tpIntermedio', e.target.value)}>
            <option value="">—</option>
            <option value="1">1 - Por conta própria</option>
            <option value="2">2 - Por conta e ordem</option>
            <option value="3">3 - Por encomenda</option>
          </select>
        </F>
        {(di.tpIntermedio === '2' || di.tpIntermedio === '3') && (
          <>
            <F label="CNPJ/CPF do adquirente" required>{txt(di.CNPJ, v => setDi('CNPJ', v.replace(/[^0-9A-Za-z]/g, '').toUpperCase()), 14)}</F>
            <F label="UF do adquirente" required>{txt(di.UFTerceiro, v => setDi('UFTerceiro', v.toUpperCase()), 2)}</F>
          </>
        )}
        <F label="Código do exportador" required>{txt(di.cExportador, v => setDi('cExportador', v), 60)}</F>
        <F label="Nº da adição">{txt(ad.nAdicao, v => setAd('nAdicao', v), 3)}</F>
        <F label="Sequencial na adição" required>{txt(ad.nSeqAdic, v => setAd('nSeqAdic', v), 5)}</F>
        <F label="Fabricante estrangeiro" required>{txt(ad.cFabricante, v => setAd('cFabricante', v), 60)}</F>
        <F label="Drawback (ato concessório)">{txt(ad.nDraw, v => setAd('nDraw', v), 20)}</F>
        <F label="II: base R$" required><MoneyInput style={inp} value={ii.vBC || 0} onChange={v => setIi('vBC', v)} /></F>
        <F label="Despesas aduaneiras R$" required><MoneyInput style={inp} value={ii.vDespAdu || 0} onChange={v => setIi('vDespAdu', v)} /></F>
        <F label="Valor do II R$" required><MoneyInput style={inp} value={ii.vII || 0} onChange={v => setIi('vII', v)} /></F>
        <F label="IOF R$" required><MoneyInput style={inp} value={ii.vIOF || 0} onChange={v => setIi('vIOF', v)} /></F>
      </div>
    </div>
  );
}

// CE5: exportação (nota de saída para destinatário do exterior). Campos do grupo de embarque
// (MOC 7.0, Anexo I, ZA02-ZA04) e do detalhe da exportação do item (I50-I55).
export const UFS_EMBARQUE = ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MG', 'MS', 'MT', 'PA',
  'PB', 'PE', 'PI', 'PR', 'RJ', 'RN', 'RO', 'RR', 'RS', 'SC', 'SE', 'SP', 'TO'];

export function ehExportacao(clienteInfo, dadosNfe) {
  return String(clienteInfo?.uf || '').toUpperCase() === 'EX' && Number(dadosNfe?.tipo_operacao) === 1;
}

export function ExportacaoNota({ dadosNfe, setDadosNfe, inp, F }) {
  const exp = dadosNfe.exportacao || {};
  const set = (k, v) => setDadosNfe({ ...dadosNfe, exportacao: { ...exp, [k]: v } });
  return (
    <div>
      <p style={{ fontSize: 12, color: '#666', marginTop: 0, marginBottom: 10 }}>
        Nota de exportação: informe onde a mercadoria embarca ou sai do país. Na exportação o ICMS
        do item é CST 41 (regime normal) ou CSOSN 300 (Simples).
      </p>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 2fr', gap: '8px' }}>
        <F label="UF de embarque" required>
          <select style={inp} value={exp.uf_saida || ''} onChange={e => set('uf_saida', e.target.value)}>
            <option value="">—</option>
            {UFS_EMBARQUE.map(u => <option key={u} value={u}>{u}</option>)}
          </select>
        </F>
        <F label="Local de embarque ou de saída do país" required>
          <input style={inp} maxLength={60} value={exp.local_embarque || ''} onChange={e => set('local_embarque', e.target.value)} />
        </F>
        <F label="Local de despacho (recinto alfandegado, opcional)">
          <input style={inp} maxLength={60} value={exp.local_despacho || ''} onChange={e => set('local_despacho', e.target.value)} />
        </F>
      </div>
    </div>
  );
}

export function ExportacaoItem({ item, upd, idx, inp, F }) {
  const d = (Array.isArray(item.exportacao) ? item.exportacao[0] : item.exportacao) || {};
  const ind = d.exportInd || {};
  const cfop = String(item.cfop || '').replace(/\D/g, '');
  const setD = (k, v) => upd(idx, 'exportacao', { ...d, [k]: v });
  const setInd = (k, v) => upd(idx, 'exportacao', { ...d, exportInd: { ...ind, [k]: v } });
  return (
    <div style={{ border: '1px dashed #ccc', borderRadius: '8px', padding: '10px 12px', margin: '8px 0' }}>
      <div style={{ fontSize: '12px', color: '#666', marginBottom: '8px' }}>
        Exportação do item {cfop === '7127' ? '— drawback: informe o ato concessório' : ''}
        {cfop === '7501' ? '— exportação de mercadoria recebida com fim específico: informe a nota recebida' : ''}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
        <F label="Ato concessório de drawback" required={cfop === '7127'}>
          <input style={inp} maxLength={20} value={d.nDraw || ''} onChange={e => setD('nDraw', e.target.value.replace(/\D/g, ''))} />
        </F>
        {cfop === '7501' && (
          <>
            <F label="Chave da NF-e recebida com fim específico" required>
              <input style={inp} maxLength={44} value={ind.chNFe || ''} onChange={e => setInd('chNFe', e.target.value.replace(/[^0-9A-Za-z]/g, '').toUpperCase())} />
            </F>
            <F label="Nº do registro de exportação (até 12 dígitos)">
              <input style={inp} maxLength={12} value={ind.nRE || ''} onChange={e => setInd('nRE', e.target.value.replace(/\D/g, ''))} />
            </F>
            <F label="Quantidade exportada" required>
              <input style={inp} value={ind.qExport ?? ''} onChange={e => setInd('qExport', e.target.value.replace(',', '.'))} />
            </F>
          </>
        )}
      </div>
      {cfop === '7501' && (
        <div style={{ fontSize: '12px', color: '#666', marginTop: '6px' }}>
          A chave da nota recebida também precisa estar em "NF-e REFERENCIADAS".
        </div>
      )}
    </div>
  );
}
